import React from 'react';
import {useNavigation, useRoute} from '@react-navigation/native';
import {createStackNavigator} from '@react-navigation/stack';
import {get} from 'lodash';

import KeyboardAvoidingView from '/component/layout/KeyboardAvoidingView';
import {createPopoverProvider} from '/provider/PopoverProvider';

import {Edge365CongratulationsScreen} from '../Edge365CongratulationsScreen/Edge365CongratulationsScreen';
import {Edge365MainScreen} from '../Edge365MainScreen';
import {EdgeChallengeDateParams} from '../Edge365MainScreen/Edge365MainScreen';

const Stack = createStackNavigator();
const popoverProvider = createPopoverProvider();
const {Provider: PopoverProvider, Consumer: PopoverConsumer} = popoverProvider;

interface Edge365ChallengeScreenProps {
  edge365ChallengeTasks: any;
  hasEdge365ChallengeTasks: boolean;
  getEdge365ChallengeTasks: (params: EdgeChallengeDateParams) => void;
  latestStreakData: any;
  coachId: string;
}

const MainScreenWrapper = ({
  coachId,
}: {
  edge365ChallengeTasks: any;
  hasEdge365ChallengeTasks: boolean;
  getEdge365ChallengeTasks: (params: EdgeChallengeDateParams) => void;
  resetEdge365ChallengeTasks: () => void;
  latestStreakData: any;
  coachId: string;
}) => {
  return (
    <PopoverConsumer>
      {({popoverShow}: any) => (
        <Edge365MainScreen popoverShow={popoverShow} coachId={coachId} />
      )}
    </PopoverConsumer>
  );
};

const ThirdScreenWrapper = () => {
  const navigation = useNavigation();
  return (
    <PopoverConsumer>
      {({popoverShow}: any) => (
        <Edge365CongratulationsScreen
          popoverShow={popoverShow}
          onClosePress={() => navigation.navigate('edge365-second-screen')}
        />
      )}
    </PopoverConsumer>
  );
};

export const Edge365ChallengeScreen = ({
  getEdge365ChallengeTasks,
  hasEdge365ChallengeTasks,
  edge365ChallengeTasks,
  latestStreakData,
}: Edge365ChallengeScreenProps) => {
  const route = useRoute();
  const coachId = get(route, 'params.coachId', '');

  return (
    <PopoverProvider>
      <KeyboardAvoidingView>
        <Stack.Navigator screenOptions={{headerShown: false}}>
          <Stack.Screen
            name="edge365-second-screen"
            children={() => (
              <MainScreenWrapper
                key={coachId}
                latestStreakData={latestStreakData}
                edge365ChallengeTasks={edge365ChallengeTasks}
                hasEdge365ChallengeTasks={hasEdge365ChallengeTasks}
                getEdge365ChallengeTasks={getEdge365ChallengeTasks}
                coachId={coachId}
              />
            )}
          />
          <Stack.Screen
            name="edge365-third-screen"
            component={ThirdScreenWrapper}
          />
        </Stack.Navigator>
      </KeyboardAvoidingView>
    </PopoverProvider>
  );
};

export default Edge365ChallengeScreen;
